export const AI_REFERRERS: Record<string, string> = {
  'chat.openai.com': 'ChatGPT',
  'chatgpt.com': 'ChatGPT',
  'perplexity.ai': 'Perplexity',
  'claude.ai': 'Claude',
  'copilot.microsoft.com': 'Microsoft Copilot',
  'gemini.google.com': 'Google Gemini',
  'bing.com': 'Bing AI',
};

export function detectAIReferral(): string | null {
  if (typeof window === 'undefined') return null;
  const referrer = document.referrer;
  if (!referrer) return null;
  for (const [domain, name] of Object.entries(AI_REFERRERS)) {
    if (referrer.includes(domain)) return name;
  }
  return null;
}
